import { render, staticRenderFns } from "./FormSupplierContent.vue?vue&type=template&id=45f75dfb&"
import script from "./FormSupplierContent.vue?vue&type=script&lang=js&"
export * from "./FormSupplierContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports